import { createSearchParams, generatePath } from 'react-router-dom'
import { api } from '../config/api'

function removeTrailingSlash(str) {
  return str.replace(/\/+$/, '')
}
var isObj = function(a) {
  if ((!!a) && (a.constructor === Object)) {
    return true;
  }
  return false;
};
var _st = function(z, g) {
  return "" + (g != "" ? "[" : "") + z + (g != "" ? "]" : "");
};
var fromObject = function(params, skipobjects, prefix) {
  if (skipobjects === void 0) {
    skipobjects = false;
  }
  if (prefix === void 0) {
    prefix = "";
  }
  var result = "";
  if (typeof(params) != "object") {
    return prefix + "=" + encodeURIComponent(params) + "&";
  }
  for (var param in params) {
    var c = "" + prefix + _st(param, prefix);
    if (isObj(params[param]) && !skipobjects) {
      result += fromObject(params[param], false, "" + c);
    } else if (Array.isArray(params[param]) && !skipobjects) {
      params[param].forEach(function(item, ind) {
        result += fromObject(item, false, c + "[" + ind + "]");
      });
    } else {
      result += c + "=" + encodeURIComponent(params[param]) + "&";
    }
  }
  return result;
};

export const generateGetApiUrl = (baseRoute, getParams = {}) => {
  if (typeof getParams == 'object') getParams = fromObject(getParams);
  return api.domain + baseRoute + (getParams.length ? '?' + getParams : '')
}

export const generateGetUrl = (baseRoute, getParams = {}) => {
  if (typeof getParams == 'object') getParams = fromObject(getParams);
  return baseRoute + (getParams.length ? '?' + getParams : '')
}

export const generateApiUrl = (baseRoute, params, baseUri) => {
  let url = (baseUri ? baseUri : api.domain) + generatePath(baseRoute, params)
  return removeTrailingSlash(url)
}

export const generateApiUrlWithGetParams = (baseRoute, params, baseUri, getParams) => {
  if (typeof getParams == 'object') getParams = fromObject(getParams);
  let url = (baseUri ? baseUri : api.domain) + generatePath(baseRoute, params) + ((getParams && getParams.length )? '?' + getParams : '')
  return removeTrailingSlash(url)
}
